import Dashboard from '../dashboard/containers';
import pageLayoutHoc from '../../hocs/pageLayoutHoc';
import userRoleBaseAccessHoc from '../../hocs/userRoleBaseAccessHoc';
import dashboardWrapper from './containers'
export const dashboardRoutes = [
  {
    path: '/dashboard',
    component: pageLayoutHoc(userRoleBaseAccessHoc(dashboardWrapper(Dashboard),['maintenance', 'dashboard','R']), {apps: 'Dashboard', layoutPhase: 1}),
    key: 'Dashboard'
  },
  {
    path: '/fleet/maintenance/dashboard',
    component: pageLayoutHoc(userRoleBaseAccessHoc(dashboardWrapper(Dashboard),['maintenance', 'dashboard','R']), {apps: 'Dashboard', layoutPhase: 1}),
    key: 'Dashboard'
  }
]
